const pageNameLocalizationMap = {
  contact: {
    sk: 'kontakt',
    en: 'contact',
  },
  projects: {
    sk: 'projekty',
    en: 'projects',
  },
  approach: {
    sk: 'pristup',
    en: 'approach',
  },
  'cx-transformation': {
    sk: 'cx-transformacia',
    en: 'cx-transformation',
  },
  'service-design': {
    sk: 'servis-dizajn',
    en: 'service-design',
  },
  redesign: {
    sk: 'redizajn',
    en: 'redesign',
  },
  'ux-optimization': {
    sk: 'ux-optimalizacia',
    en: 'ux-optimization',
  },
  insights: {
    sk: 'blog',
    en: 'blog',
  },
  services: {
    sk: 'pristup',
    en: 'approach',
  },
  'thank-you': {
    sk: 'dakujeme',
    en: 'thank-you',
  },
};

// if there is no translation for page name, the original page name will be used
export const getLocalizedPageName = (pageName, locale) => {
  if (pageNameLocalizationMap[pageName]) {
    if (pageNameLocalizationMap[pageName][locale]) {
      return pageNameLocalizationMap[pageName][locale];
    }
    return pageName;
  }
  return pageName;
};

export const getLocalizedPageFileName = (pageName, locale) => {
  const localizedPageName = getLocalizedPageName(pageName, locale);
  let pageFileName;

  // EN locale is default, without prefix
  if (locale === 'en') {
    pageFileName = localizedPageName;
  } else {
    pageFileName = `${locale}/${localizedPageName}`;
  }

  return `${pageFileName}.html`;
};

export const getLocalizedPageUrl = (pageName, locale) => {
  // blog is outside this system and lives on /blog no matter locale
  if (pageName === 'blog') {
    return `/blog`;
  }

  let localizedPageName;

  // do not show "index" in URLs
  if (pageName === 'index') {
    localizedPageName = '';
  } else {
    localizedPageName = getLocalizedPageName(pageName, locale);
  }

  let pageUrl;

  // EN locale is default, without prefix
  if (locale === 'en') {
    pageUrl = localizedPageName;
  } else {
    pageUrl = `${locale}/${localizedPageName}`;
  }

  return `/${pageUrl}`;
};



// WEBPACK FOOTER //
// ./src/modules/Navigation/index.js